import { STORAGE_KEY } from "@/constants/storage-keys";

interface TokenType {
  readonly accessToken: string;
  readonly refreshToken: string;
  readonly idToken: string;
  readonly email?: string;
}

interface StorageTokens {
  readonly accessToken: string | null;
  readonly refreshToken: string | null;
  readonly idToken: string | null;
  readonly email: string | null;
}

const setLocalTokens = (tokens: TokenType) => {
  localStorage.setItem(STORAGE_KEY.AccessToken, tokens.accessToken);
  localStorage.setItem(STORAGE_KEY.RefreshToken, tokens.refreshToken);
  localStorage.setItem(STORAGE_KEY.IdToken, tokens.idToken);
  if (tokens.email !== undefined) {
    localStorage.setItem(STORAGE_KEY.Email, tokens.email);
  }
};
const getLocalTokens = () => {
  const accessToken = localStorage.getItem(STORAGE_KEY.AccessToken);
  const refreshToken = localStorage.getItem(STORAGE_KEY.RefreshToken);
  const idToken = localStorage.getItem(STORAGE_KEY.IdToken);
  const email = localStorage.getItem(STORAGE_KEY.Email);

  return {
    accessToken,
    refreshToken,
    idToken,
    email,
  } as StorageTokens;
};

const removeLocalTokens = () => {
  localStorage.removeItem(STORAGE_KEY.AccessToken);
  localStorage.removeItem(STORAGE_KEY.RefreshToken);
  localStorage.removeItem(STORAGE_KEY.IdToken);
};

const tokenService = () => {
  return {
    setLocalTokens,
    getLocalTokens,
    removeLocalTokens,
  };
};

export default tokenService;